import React, {useState} from 'react';
import CustomLinesEllipsis from "../Mydata/CustomLinesEllipsis.js";
import user from "../../assets/img/userbig.png";
import moment from "moment";
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import {useDispatch, useSelector} from "react-redux";
import DeleteItem from "./DeleteItem.js";
import qs from "query-string";
import Api from "../../Api.js";
import {dayOffAddLocalRequest} from "../../store/actions/dayoff.js";
import SuccessToast from "../BlueButton/SuccessToast.js";
import PublishedWithChangesIcon from '@mui/icons-material/PublishedWithChanges';
import ErrorToast from "../BlueButton/ErrorToast.js";
function DayOffItem({item}) {
    const [show, setShow] = useState(false)
    const [deleteId, setDelete] = useState(0)
    const isAllowed = item?.creator?.id === +localStorage.getItem('user_id')
    const accountantArray = useSelector((state) => state.manager.accountantArray) || []
    const login = useSelector((state) => state.manager.employee);
    const isManager = login.user_id === 86 ||login.user_id === 1024 || login.user_id ===414 || login.user_id ===2|| login.user_id ===1734 || login.user_id === 1918
    const dispatch = useDispatch()
    const query = qs.parse(location.search, {arrayFormat: 'comma'});
    const handleStatusChange = async (status) => {
       try {
           const formData = new FormData()
           formData.append('approved', status)
           await Api.statusDayOff(item.id, formData)
           let querystring = qs.stringify(query, {
               arrayFormat: 'comma',
               skipEmptyString: true,
           })
           const {data} = await Api.getDayOff(querystring)
           dispatch(dayOffAddLocalRequest(data))
           SuccessToast()
       }catch (e) {
           ErrorToast()
       }
    }
    return (
        <div className='recommendations-item card' style={item?.approved === 1?{backgroundColor:'#daffc0',height: !isManager && !accountantArray.includes(item?.creator?.id)?225 : 280}:item?.approved === 2?{backgroundColor: '#ffe0e0',height:!isManager && !accountantArray.includes(item?.creator?.id)?225 : 280}:item?.is_sent?{backgroundColor: '#cffff9',height: !isManager && !accountantArray.includes(item?.creator?.id)?225 : 280}:{height: !isManager && !accountantArray.includes(item?.creator?.id)?225 : 280}}>
            <div className="recommendations-item-cont">
                <div className="card-overflow">
                    <div className="recommendations-item-top">
                        <div className='recommendations-item-heading'>
                            {item?.title}
                        </div>

                    </div>
                    <div className='recommendations-item-text'>
                        <CustomLinesEllipsis text={item?.text} maxLines={5}/>

                        <div className="process-file-message">
                            <div>{item?.approved === 0?"Դիտարկվում է":item?.approved === 1?'Հաստատված է':"Մերժված է"}</div>
                            <div className="recommendations-item-text-icon-cont"/>
                        </div>
                        <div>{item?.is_sent === 1?'Փոխանցված':''}</div>

                    </div>
                    <div className='recommendations-item-bottom'>
                        <hr/>
                        <div className='image-calendar'>
                            <div className="image-name-emplayee">
                                <img alt="img" className='task-image' src={item?.creator?.image || item?.manager?.image || user}/>
                                <span
                                    className="name-emplayee">{`${item?.creator?.first_name} ${item?.creator?.last_name}`}</span>
                            </div>
                            <span className='calendar'>
                            <span className='icon-Calendar'/>
                            <div className="task-date-cont">
                                <span className='moment'>Ստղ. {item?.created_date ? moment(item?.created_date).format('LLL') : null}</span>
                                <span className='moment'>Day off սկիզբ {item?.start_date ? moment(item?.start_date).format('LLL') : null}</span>
                                <span className='moment'>Day off ավարտ {item?.end_date ? moment(item?.end_date).format('LLL') : null}</span>
                            </div>
                        </span>
                        </div>
                        {(isManager && !isAllowed)|| accountantArray.includes(item?.creator?.id)?<hr className="myhr"/>:null}
                        {(isManager && !isAllowed) || accountantArray.includes(item?.creator?.id)?<div className="d-flex justify-content-between">
                            <div onClick={() => handleStatusChange(1)}><CheckIcon style={{color:'#00ff00'}}/> Հաստատել</div>
                            { item?.approved === 0?<span style={{height:25, width:2, backgroundColor:'#ccc', display:'inline-block'}}/>:null}
                            {  item?.approved === 0?<div onClick={() => handleStatusChange(3)}><PublishedWithChangesIcon style={{color:'#0066ff'}}/>{item.is_sent?'Հետ Ուղարկել':'Փոխանցել'} </div>:null}
                            <span style={{height:25, width:2, backgroundColor:'#ccc', display:'inline-block'}}/>
                            <div onClick={() => handleStatusChange(2)}><CloseIcon style={{color:'#ff0000'}}/> Մերժել</div>
                        </div>:null}

                    </div>

                </div>
            </div>




            {show && <div className='options'>
                {isAllowed ? (
                    <p className='options-item' onClick={() => setDelete(item.id)}>Ջնջել</p>
                ) : null}
            </div>}
            {isAllowed ? <span className="icon-Options" onClick={() => setShow(!show)}/> : null}
            {deleteId ? <DeleteItem open={deleteId} setOpen={setDelete}/>: null}
        </div>
    );
}

export default DayOffItem;